/*
 * Tone is a second signal, never the only one: the badge always renders its
 * own text, so a reader who cannot separate the hues still reads the state.
 * Geometry is the mockup's `.badge`: 20px pill, 12px medium text.
 */
.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  block-size: 20px;
  padding: 0 var(--space-2);
  border-radius: var(--radius-pill);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
}

.neutral {
  background: var(--surface-sunken);
  color: var(--text-muted);
}

.success {
  background: var(--success-surface);
  color: var(--success-text);
}

.warning {
  background: var(--warning-surface);
  color: var(--warning-text);
}

.danger {
  background: var(--danger-surface);
  color: var(--danger-text);
}

.info {
  background: var(--info-surface);
  color: var(--info-text);
}

/* The mockup's `.badge-outline`: a label that names a fact (a scope), not a state. */
.outline {
  background: transparent;
  border: 1px solid var(--border-strong);
  color: var(--text-muted);
}
